(() => {
  'use strict';

  if (window.__PW_HEADER_92__) return;
  window.__PW_HEADER_92__ = true;

  if (!window.__PW_MOBILE_MENU_IMMEDIATE__) {
    window.__PW_MOBILE_MENU_IMMEDIATE__ = true;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[aria-controls="MobileNav"]');
      if (!trigger || !trigger.closest('toggle-menu')) return;

      event.preventDefault();
      event.stopPropagation();

      const drawer = document.querySelector('.site-header__mobile-nav');
      const isOpen = trigger.classList.contains('is-active')
        || drawer?.classList.contains('is-active');
      const willOpen = !isOpen;

      trigger.classList.toggle('is-active', willOpen);
      trigger.setAttribute('aria-expanded', String(willOpen));
      trigger.dispatchEvent(new CustomEvent(
        willOpen ? 'mobileNav:open' : 'mobileNav:close',
        { bubbles: true }
      ));
    }, true);
  }

  const productCache = new Map();
  let productRenderSerial = 0;
  let lastModalTrigger = null;

  const PW_ANALYTICS_ENDPOINT = 'https://packaging-wise-upsell-crosssell.vercel.app/api/storefront-events';
  const sendMerchandisingEvent = (eventType, extra = {}) => {
    const shop = window.Shopify?.shop || '5c58e2.myshopify.com';
    const payload = JSON.stringify({
      eventType,
      shop,
      path: window.location.pathname,
      source: 'pw_header',
      ...(window.PWAnalytics?.context?.() || {}),
      ...extra
    });
    window.PWAnalytics?.send?.(PW_ANALYTICS_ENDPOINT, payload).catch?.(() => {});
  };

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[char]);

  const money = (raw) => {
    if (raw == null || raw === '') return '';
    const source = String(raw);
    let amount = Number(raw);
    if (!Number.isFinite(amount)) return source;
    if (!source.includes('.') && Number.isInteger(amount)) amount /= 100;
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(amount);
  };

  const packFromTitle = (title) => {
    const match = String(title || '').match(/\(\s*1\s*x\s*([\d,]+)\s*\)|pack\s+of\s+([\d,]+)/i);
    return match ? Number(String(match[1] || match[2]).replace(/,/g, '')) : 0;
  };

  const imageUrl = (url, width = 360) => url
    ? url + (url.includes('?') ? '&' : '?') + 'width=' + width
    : '';

  async function getProducts(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    const request = fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=24', {
      credentials: 'same-origin',
      cache: 'force-cache'
    })
      .then((response) => response.ok ? response.json() : Promise.reject(response))
      .then((payload) => payload.products || [])
      .catch(() => []);
    productCache.set(handle, request);
    return request;
  }

  function productCard(product) {
    const variants = product.variants || [];
    const variant = variants.find((item) => item.available) || variants[0];
    const image = product.images?.[0]?.src || product.image?.src || '';
    const pack = packFromTitle(product.title);
    const price = variant ? money(variant.price) : '';
    const available = Boolean(variant?.available);
    let unit = '';

    if (pack && variant) {
      const source = String(variant.price || '');
      let amount = Number(variant.price || 0);
      if (!source.includes('.') && Number.isInteger(amount)) amount /= 100;
      if (amount > 0) unit = money((amount / pack).toFixed(3)) + ' per unit';
    }

    return [
      '<article class="pw-mega-product">',
      '<a class="pw-mega-product__image" href="/products/', encodeURIComponent(product.handle), '">',
      image ? '<img src="' + escapeHtml(imageUrl(image)) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '',
      '</a>',
      '<div class="pw-mega-product__body">',
      '<a class="pw-mega-product__title" href="/products/', encodeURIComponent(product.handle), '">', escapeHtml(product.title), '</a>',
      pack ? '<div class="pw-mega-product__pack">Pack of ' + pack.toLocaleString('en-GB') + ' units</div>' : '',
      '<div class="pw-mega-product__price">',
      '<span>', price, '</span>',
      unit ? '<span class="pw-mega-product__unit">(' + unit + ')</span>' : '',
      '</div>',
      '<button class="pw-mega-product__add" type="button" data-pw-mega-add data-id="', variant?.id || '', '" ',
      available ? '' : 'disabled',
      '>', available ? 'Add to cart' : 'Sold out', '</button>',
      '</div></article>'
    ].join('');
  }

  async function renderProducts(host, handle, title, url) {
    const renderKey = String(++productRenderSerial);
    host.dataset.pwRenderKey = renderKey;
    host.innerHTML = '<div class="pw-category-mega__state">Loading products…</div>';
    const products = await getProducts(handle);
    if (host.dataset.pwRenderKey !== renderKey) return;
    if (!products.length) {
      host.innerHTML = '<div class="pw-category-mega__state">No products found.</div>';
      return;
    }
    host.innerHTML = [
      '<div class="pw-category-mega__head"><h3>', escapeHtml(title),
      '</h3><a class="pw-category-mega__view" href="', escapeHtml(url), '">View all</a></div>',
      '<div class="pw-category-products">',
      products.map(productCard).join(''),
      '</div>'
    ].join('');
  }

  async function addVariant(button) {
    const id = button.dataset.id;
    if (!id || button.disabled) return;
    const oldLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: Number(id), quantity: 1 }],
          sections: ['cart-ajax'],
          sections_url: location.pathname
        })
      });
      const data = await response.json();
      if (!response.ok) throw data;
      sendMerchandisingEvent('header_mega_add', {
        variantId: id,
        action: 'add_to_cart',
        placement: 'header_mega_menu'
      });
      button.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: { product: data }
      }));
      window.setTimeout(() => {
        button.textContent = oldLabel;
        button.disabled = false;
      }, 1000);
    } catch (error) {
      if (error?.name === 'PWCompatibilityCancelled') {
        button.textContent = oldLabel;
        button.disabled = false;
        return;
      }
      button.textContent = 'Try again';
      window.setTimeout(() => {
        button.textContent = oldLabel;
        button.disabled = false;
      }, 1300);
    }
  }

  function alignDesktopMegaMenu(details, dropdown) {
    const nav = details.closest('.site-header__element--sub[data-type="nav"]')
      || document.querySelector('.site-header__element--sub[data-type="nav"]');
    if (!nav) return;
    dropdown.style.setProperty('--pw-mega-top', `${Math.max(0, nav.getBoundingClientRect().bottom)}px`);
  }

  function initDesktopMegaMenu() {
    const template = document.getElementById('PWCategoryMegaTemplate');
    if (!template) return;

    document.querySelectorAll('.site-nav__details').forEach((details) => {
      const summary = details.querySelector(':scope > summary');
      if (!summary || !/^shop\s*by\s*category$/i.test(summary.textContent.trim())) return;
      const dropdown = details.querySelector('.site-nav__dropdown');
      if (!dropdown) return;
      if (dropdown.dataset.pwReady) return;

      details.classList.add('pw-category-menu-details');
      details.closest('li')?.classList.add('pw-category-menu-item');
      dropdown.dataset.pwReady = '1';
      dropdown.classList.add('pw-category-dropdown');
      dropdown.innerHTML = '<div class="page-width"></div>';
      const pageWidth = dropdown.querySelector('.page-width');
      if (!pageWidth) return;
      pageWidth.append(template.content.cloneNode(true));

      const root = dropdown.querySelector('.pw-category-mega');
      if (!root) return;
      const productHost = root.querySelector('[data-pw-products]');
      if (!productHost) return;
      const buttons = [...root.querySelectorAll('[data-pw-category]')];
      const allButton = root.querySelector('[data-pw-category-all]');
      const allCollectionsMarkup = productHost.innerHTML;
      let closeTimer;
      let pointerInside = false;

      const activate = (button) => {
        [allButton, ...buttons].filter(Boolean).forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });
        renderProducts(productHost, button.dataset.handle, button.dataset.title, button.dataset.url);
      };

      const activateAll = () => {
        productHost.dataset.pwRenderKey = String(++productRenderSerial);
        [allButton, ...buttons].filter(Boolean).forEach((item) => {
          const active = item === allButton;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });
        productHost.innerHTML = allCollectionsMarkup;
      };

      const open = () => {
        window.clearTimeout(closeTimer);
        alignDesktopMegaMenu(details, dropdown);
        details.open = true;
      };

      const close = (immediate = false) => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (!pointerInside && !details.matches(':hover')) details.open = false;
        }, immediate ? 0 : 90);
      };

      details.addEventListener('mouseenter', () => {
        pointerInside = true;
        open();
      });
      details.addEventListener('mouseleave', () => {
        pointerInside = false;
        close();
      });
      details.addEventListener('focusin', open);
      details.addEventListener('focusout', () => close());
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        window.location.href = '/collections';
      });
      allButton?.addEventListener('mouseenter', activateAll);
      allButton?.addEventListener('focus', activateAll);
      buttons.forEach((button) => {
        button.addEventListener('mouseenter', () => activate(button));
        button.addEventListener('focus', () => activate(button));
      });
      activateAll();
    });

    if (!window.__pwMegaResize) {
      window.__pwMegaResize = true;
      addEventListener('resize', () => {
        requestAnimationFrame(() => {
          document.querySelectorAll('.pw-category-menu-details').forEach((details) => {
            const dropdown = details.querySelector('.pw-category-dropdown');
            if (dropdown) alignDesktopMegaMenu(details, dropdown);
          });
        });
      }, { passive: true });
    }

  }

  function initMobileMegaMenu() {
    const template = document.getElementById('PWMobileCategoryTemplate');
    if (!template) return;

    document.querySelectorAll('.slide-nav__link').forEach((link) => {
      const label = link.textContent.replace(/\s+/g, ' ').trim();
      if (/^shop\s*all$/i.test(label)) link.querySelector('.slide-nav__image')?.remove();
    });

    document.querySelectorAll('.slide-nav__button.js-toggle-submenu').forEach((trigger) => {
      const label = trigger.querySelector('.slide-nav__link')?.textContent || trigger.firstElementChild?.textContent || trigger.textContent;
      const normalizedLabel = label.replace(/expand\s+submenu/ig, '').replace(/\s+/g, ' ').trim();
      if (!/^shop\s*by\s*category$/i.test(normalizedLabel)) return;
      const target = trigger.dataset.target;
      const listItem = trigger.closest('.slide-nav__item');
      const submenu = listItem?.querySelector('.slide-nav__dropdown[data-parent="' + CSS.escape(target) + '"]');
      if (!submenu || submenu.dataset.pwReady) return;

      submenu.dataset.pwReady = '1';
      [...submenu.children].forEach((child) => child.classList.add('pw-mobile-native-category'));
      const host = document.createElement('li');
      host.className = 'slide-nav__item pw-mobile-category-host';
      host.append(template.content.cloneNode(true));
      submenu.append(host);

      host.querySelectorAll('[data-pw-mobile-category]').forEach((card) => {
        card.addEventListener('click', async () => {
          const panel = host.querySelector('.pw-mobile-products-panel');
          if (!panel) return;
          const grid = panel.querySelector('[data-pw-mobile-products]');
          const heading = panel.querySelector('h3');
          const viewLink = panel.querySelector('[data-pw-mobile-view]');
          if (!grid || !heading || !viewLink) return;
          panel.hidden = false;
          heading.textContent = card.dataset.title;
          viewLink.href = card.dataset.url;
          grid.innerHTML = '<div class="pw-category-mega__state">Loading products…</div>';
          const products = await getProducts(card.dataset.handle);
          grid.innerHTML = products.map(productCard).join('')
            || '<div class="pw-category-mega__state">No products found.</div>';
        });
      });

      host.querySelector('[data-pw-mobile-back]')?.addEventListener('click', () => {
        const panel = host.querySelector('.pw-mobile-products-panel');
        if (panel) panel.hidden = true;
      });
    });
  }

  function initAccount() {
    document.documentElement.classList.add('pw-header-icons-ready');
  }

  function cleanupMobileNavChrome() {
    document.querySelectorAll('.site-header__mobile-nav shopify-account').forEach((account) => {
      const item = account.closest('.slide-nav__item');
      (item || account).remove();
    });
    document.querySelectorAll('.site-header__mobile-nav clone-footer').forEach((footer) => footer.remove());
    document.querySelectorAll('.site-header__mobile-nav .pw-mobile-quote').forEach((item) => item.remove());
  }

  function resetMobileMenu() {
    document.querySelectorAll('.site-header__mobile-nav mobile-nav').forEach((nav) => {
      if (typeof nav.goToSubnav === 'function') {
        nav.goToSubnav();
      } else {
        nav.dataset.level = '1';
        nav.style.removeProperty('height');
        nav.querySelectorAll('.slide-nav__dropdown.is-active').forEach((list) => {
          list.classList.remove('is-active');
        });
      }

      nav.querySelectorAll('.pw-mobile-products-panel').forEach((panel) => {
        panel.hidden = true;
      });

      const slide = nav.querySelector('.slide-nav');
      if (slide) slide.scrollTop = 0;
    });
  }

  function setModalView(showForm) {
    const modal = document.getElementById('PWHeaderQuoteModal');
    if (!modal) return;
    const home = modal.querySelector('[data-pw-modal-home]');
    const form = modal.querySelector('[data-pw-modal-form]');
    home.hidden = showForm;
    form.hidden = !showForm;
  }

  function openModal(event) {
    const modal = document.getElementById('PWHeaderQuoteModal');
    if (!modal) return;
    sendMerchandisingEvent('header_bespoke_open', {
      action: 'open_modal',
      placement: 'header'
    });
    lastModalTrigger = event?.currentTarget || document.activeElement;
    setModalView(false);
    modal.hidden = false;
    document.documentElement.classList.add('pw-modal-open');
    modal.querySelector('.pw-header-modal__close')?.focus();
  }

  function closeModal() {
    const modal = document.getElementById('PWHeaderQuoteModal');
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('pw-modal-open');
    lastModalTrigger?.focus?.();
  }

  function initCta() {
    const source = document.getElementById('PWHeaderCtaSource');
    const sourceButton = source?.querySelector('[data-pw-header-quote]');
    const desktopHost = document.querySelector('.header-item--icons .site-nav__icons');
    const modal = document.getElementById('PWHeaderQuoteModal');

    if (modal && modal.parentElement !== document.body) {
      document.body.append(modal);
    }

    if (sourceButton && desktopHost) {
      const misplaced = document.querySelector('.header-item--icons > .site-nav > .pw-header-cta');
      if (misplaced) desktopHost.prepend(misplaced);
      if (!desktopHost.querySelector('.pw-header-cta')) {
        desktopHost.prepend(sourceButton.cloneNode(true));
      }
    }

    const mobileHeaderHost = document.querySelector('#SiteHeader .site-header__element--top > .page-width');
    if (sourceButton && mobileHeaderHost) {
      let mobileRow = mobileHeaderHost.querySelector('.pw-bespoke-mobile-row');
      if (!mobileRow) {
        mobileRow = document.createElement('div');
        mobileRow.className = 'pw-bespoke-mobile-row medium-up--hide';
        mobileHeaderHost.append(mobileRow);
      }
      if (!mobileRow.querySelector('[data-pw-header-quote]')) {
        const button = sourceButton.cloneNode(true);
        button.classList.remove('small--hide');
        mobileRow.append(button);
      }
    }

    document.querySelectorAll('[data-pw-header-quote]').forEach((button) => {
      if (button.dataset.pwBound) return;
      button.dataset.pwBound = '1';
      button.addEventListener('click', openModal);
    });

    if (!modal || modal.dataset.pwBound) return;
    modal.dataset.pwBound = '1';
    modal.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-pw-modal-close]');
      const formButton = event.target.closest('[data-pw-modal-form-open]');
      const backButton = event.target.closest('[data-pw-modal-back]');
      const actionLink = event.target.closest('.pw-header-modal__choice[href]');

      if (closeButton) {
        event.preventDefault();
        event.stopPropagation();
        closeModal();
        return;
      }
      if (formButton) {
        event.preventDefault();
        event.stopPropagation();
        sendMerchandisingEvent('header_quote_form_open', {
          action: 'open_quote_form',
          placement: 'header_modal'
        });
        setModalView(true);
        modal.querySelector('[data-pw-modal-back]')?.focus();
        return;
      }
      if (backButton) {
        event.preventDefault();
        event.stopPropagation();
        setModalView(false);
        modal.querySelector('[data-pw-modal-form-open]')?.focus();
        return;
      }
      if (actionLink) {
        const href = actionLink.getAttribute('href') || '';
        if (href.startsWith('tel:')) {
          sendMerchandisingEvent('header_call_click', {
            action: 'call',
            placement: 'header_modal',
            target: href
          });
        } else if (href.startsWith('mailto:')) {
          sendMerchandisingEvent('header_email_click', {
            action: 'email',
            placement: 'header_modal',
            target: href
          });
        }
        closeModal();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function copyDiscount(element) {
    const done = () => {
      document.querySelectorAll('.pw-copy-toast').forEach((toast) => toast.remove());
      const toast = document.createElement('span');
      toast.className = 'pw-copy-toast';
      toast.setAttribute('role', 'status');
      toast.textContent = 'Copied WELCOME10 code';
      element.append(toast);
      window.setTimeout(() => toast.remove(), 1700);
    };

    const fallback = () => {
      const field = document.createElement('textarea');
      field.value = 'WELCOME10';
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.append(field);
      field.select();
      try {
        document.execCommand('copy');
        done();
      } finally {
        field.remove();
      }
    };

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText('WELCOME10').then(done).catch(fallback);
    } else {
      fallback();
    }
  }

  function initTopbar() {
    document.querySelectorAll('.announcement-slider__content, .toolbar').forEach((root) => {
      if (!/WELCOME10/i.test(root.textContent || '')) return;
      const element = root.closest('.announcement-bar, .toolbar') || root;
      if (element.parentElement?.closest('.pw-topbar-message')) return;
      if (!element || element.dataset.pwCopy) return;
      element.dataset.pwCopy = '1';
      element.classList.add('pw-topbar-message');
      element.setAttribute('aria-label', 'Copy discount code WELCOME10');
      element.addEventListener('click', () => copyDiscount(element));
      if (!element.matches('.toolbar, .announcement-bar')) {
        element.setAttribute('role', 'button');
        element.setAttribute('tabindex', '0');
        element.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            copyDiscount(element);
          }
        });
      }
    });
  }

  function init() {
    cleanupMobileNavChrome();
    if (!document.querySelector('.site-header__mobile-nav.is-active')) resetMobileMenu();
    initDesktopMegaMenu();
    initMobileMegaMenu();
    initAccount();
    initCta();
    initTopbar();
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pw-mega-add]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    addVariant(button);
  });

  document.addEventListener('mobileNav:open', resetMobileMenu, true);
  document.addEventListener('mobileNav:close', () => {
    requestAnimationFrame(resetMobileMenu);
  }, true);
  document.addEventListener('headerDrawer:closed', (event) => {
    if (event.target.matches?.('.site-header__mobile-nav')) resetMobileMenu();
  });

  let lastScrollY = 0;
  addEventListener('scroll', () => {
    const current = scrollY;
    if (Math.abs(current - lastScrollY) < 12) return;
    lastScrollY = current;
    document.documentElement.classList.toggle('pw-header-scrolled', current > 100);
    document.querySelectorAll('.pw-category-menu-details[open]').forEach((details) => {
      const dropdown = details.querySelector('.pw-category-dropdown');
      if (dropdown) alignDesktopMegaMenu(details, dropdown);
    });
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
